/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import { default as ActivityIcon } from './activityIcon';
import { default as AddCircleIcon } from './addCircleIcon';
import { default as AddIcon } from './addIcon';
import { default as ArchiveIcon } from './archiveIcon';
import { default as ArrowDownIcon } from './arrowDownIcon';
import { default as ArrowLeftIcon } from './arrowLeftIcon';
import { default as ArrowRightIcon } from './arrowRightIcon';
import { default as ArrowUpIcon } from './arrowUpIcon';
import { default as BellIcon } from './bellIcon';
import { default as BillIcon } from './billIcon';
import { default as BinaryDocumentIcon } from './binaryDocumentIcon';
import { default as BlockElementIcon } from './blockElementIcon';
import { default as BlockquoteIcon } from './blockquoteIcon';
import { default as BoldIcon } from './boldIcon';
import { default as BookIcon } from './bookIcon';
import { default as BottleIcon } from './bottleIcon';
import { default as BulbFilledIcon } from './bulbFilledIcon';
import { default as BulbOutlineIcon } from './bulbOutlineIcon';
import { default as CalendarIcon } from './calendarIcon';
import { default as ChartUpwardIcon } from './chartUpwardIcon';
import { default as CheckmarkCircleIcon } from './checkmarkCircleIcon';
import { default as CheckmarkIcon } from './checkmarkIcon';
import { default as ChevronDownIcon } from './chevronDownIcon';
import { default as ChevronLeftIcon } from './chevronLeftIcon';
import { default as ChevronRightIcon } from './chevronRightIcon';
import { default as ChevronUpIcon } from './chevronUpIcon';
import { default as CircleIcon } from './circleIcon';
import { default as ClipboardIcon } from './clipboardIcon';
import { default as ClipboardImageIcon } from './clipboardImageIcon';
import { default as ClockIcon } from './clockIcon';
import { default as CloseCircleIcon } from './closeCircleIcon';
import { default as CloseIcon } from './closeIcon';
import { default as CodeBlockIcon } from './codeBlockIcon';
import { default as CodeIcon } from './codeIcon';
import { default as CogIcon } from './cogIcon';
import { default as CollapseIcon } from './collapseIcon';
import { default as CommentIcon } from './commentIcon';
import { default as ComponentIcon } from './componentIcon';
import { default as ComposeIcon } from './composeIcon';
import { default as ControlsIcon } from './controlsIcon';
import { default as DashboardIcon } from './dashboardIcon';
import { default as DatabaseIcon } from './databaseIcon';
import { default as DocumentIcon } from './documentIcon';
import { default as DocumentRemoveIcon } from './documentRemoveIcon';
import { default as DocumentsIcon } from './documentsIcon';
import { default as DownloadIcon } from './downloadIcon';
import { default as DragHandleIcon } from './dragHandleIcon';
import { default as DropIcon } from './dropIcon';
import { default as EarthAmericasIcon } from './earthAmericasIcon';
import { default as EarthGlobeIcon } from './earthGlobeIcon';
import { default as EditIcon } from './editIcon';
import { default as EllipsisHorizontalIcon } from './ellipsisHorizontalIcon';
import { default as EllipsisVerticalIcon } from './ellipsisVerticalIcon';
import { default as EqualIcon } from './equalIcon';
import { default as ErrorFilledIcon } from './errorFilledIcon';
import { default as ErrorOutlineIcon } from './errorOutlineIcon';
import { default as ExpandIcon } from './expandIcon';
import { default as EyeClosedIcon } from './eyeClosedIcon';
import { default as EyeOpenIcon } from './eyeOpenIcon';
import { default as FolderIcon } from './folderIcon';
import { default as GenerateIcon } from './generateIcon';
import { default as HeartIcon } from './heartIcon';
import { default as HelpCircleIcon } from './helpCircleIcon';
import { default as HomeIcon } from './homeIcon';
import { default as IceCreamIcon } from './iceCreamIcon';
import { default as ImageIcon } from './imageIcon';
import { default as ImageRemoveIcon } from './imageRemoveIcon';
import { default as ImagesIcon } from './imagesIcon';
import { default as InfoFilledIcon } from './infoFilledIcon';
import { default as InfoOutlineIcon } from './infoOutlineIcon';
import { default as InlineElementIcon } from './inlineElementIcon';
import { default as ItalicIcon } from './italicIcon';
import { default as JoystickIcon } from './joystickIcon';
import { default as LaunchIcon } from './launchIcon';
import { default as LeaveIcon } from './leaveIcon';
import { default as LemonIcon } from './lemonIcon';
import { default as LinkIcon } from './linkIcon';
import { default as LinkRemovedIcon } from './linkRemovedIcon';
import { default as LockIcon } from './lockIcon';
import { default as MasterDetailIcon } from './masterDetailIcon';
import { default as MenuIcon } from './menuIcon';
import { default as MobileDeviceIcon } from './mobileDeviceIcon';
import { default as MoonIcon } from './moonIcon';
import { default as OkHandIcon } from './okHandIcon';
import { default as OlistIcon } from './olistIcon';
import { default as PackageIcon } from './packageIcon';
import { default as PauseIcon } from './pauseIcon';
import { default as PinIcon } from './pinIcon';
import { default as PinRemovedIcon } from './pinRemovedIcon';
import { default as PlayIcon } from './playIcon';
import { default as PlugIcon } from './plugIcon';
import { default as PublishIcon } from './publishIcon';
import { default as RemoveCircleIcon } from './removeCircleIcon';
import { default as RemoveIcon } from './removeIcon';
import { default as ResetIcon } from './resetIcon';
import { default as RestoreIcon } from './restoreIcon';
import { default as RevertIcon } from './revertIcon';
import { default as RobotIcon } from './robotIcon';
import { default as RocketIcon } from './rocketIcon';
import { default as SearchIcon } from './searchIcon';
import { default as SelectIcon } from './selectIcon';
import { default as SortIcon } from './sortIcon';
import { default as SpinnerIcon } from './spinnerIcon';
import { default as SplitHorizontalIcon } from './splitHorizontalIcon';
import { default as SplitVerticalIcon } from './splitVerticalIcon';
import { default as SquareIcon } from './squareIcon';
import { default as StackCompactIcon } from './stackCompactIcon';
import { default as StarIcon } from './starIcon';
import { default as StrikethroughIcon } from './strikethroughIcon';
import { default as SunIcon } from './sunIcon';
import { default as SyncIcon } from './syncIcon';
import { default as TerminalIcon } from './terminalIcon';
import { default as ThLargeIcon } from './thLargeIcon';
import { default as ThListIcon } from './thListIcon';
import { default as ToggleArrowRightIcon } from './toggleArrowRightIcon';
import { default as TokenIcon } from './tokenIcon';
import { default as TrashIcon } from './trashIcon';
import { default as TrendUpwardIcon } from './trendUpwardIcon';
import { default as TriangleOutlineIcon } from './triangleOutlineIcon';
import { default as TruncateIcon } from './truncateIcon';
import { default as UlistIcon } from './ulistIcon';
import { default as UnderlineIcon } from './underlineIcon';
import { default as UndoIcon } from './undoIcon';
import { default as UnknownIcon } from './unknownIcon';
import { default as UnlockIcon } from './unlockIcon';
import { default as UnpublishIcon } from './unpublishIcon';
import { default as UploadIcon } from './uploadIcon';
import { default as UserIcon } from './userIcon';
import { default as UsersIcon } from './usersIcon';
import { default as WarningFilledIcon } from './warningFilledIcon';
import { default as WarningOutlineIcon } from './warningOutlineIcon';
export { ActivityIcon, AddCircleIcon, AddIcon, ArchiveIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, BellIcon, BillIcon, BinaryDocumentIcon, BlockElementIcon, BlockquoteIcon, BoldIcon, BookIcon, BottleIcon, BulbFilledIcon, BulbOutlineIcon, CalendarIcon, ChartUpwardIcon, CheckmarkCircleIcon, CheckmarkIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, CircleIcon, ClipboardIcon, ClipboardImageIcon, ClockIcon, CloseCircleIcon, CloseIcon, CodeBlockIcon, CodeIcon, CogIcon, CollapseIcon, CommentIcon, ComponentIcon, ComposeIcon, ControlsIcon, DashboardIcon, DatabaseIcon, DocumentIcon, DocumentRemoveIcon, DocumentsIcon, DownloadIcon, DragHandleIcon, DropIcon, EarthAmericasIcon, EarthGlobeIcon, EditIcon, EllipsisHorizontalIcon, EllipsisVerticalIcon, EqualIcon, ErrorFilledIcon, ErrorOutlineIcon, ExpandIcon, EyeClosedIcon, EyeOpenIcon, FolderIcon, GenerateIcon, HeartIcon, HelpCircleIcon, HomeIcon, IceCreamIcon, ImageIcon, ImageRemoveIcon, ImagesIcon, InfoFilledIcon, InfoOutlineIcon, InlineElementIcon, ItalicIcon, JoystickIcon, LaunchIcon, LeaveIcon, LemonIcon, LinkIcon, LinkRemovedIcon, LockIcon, MasterDetailIcon, MenuIcon, MobileDeviceIcon, MoonIcon, OkHandIcon, OlistIcon, PackageIcon, PauseIcon, PinIcon, PinRemovedIcon, PlayIcon, PlugIcon, PublishIcon, RemoveCircleIcon, RemoveIcon, ResetIcon, RestoreIcon, RevertIcon, RobotIcon, RocketIcon, SearchIcon, SelectIcon, SortIcon, SpinnerIcon, SplitHorizontalIcon, SplitVerticalIcon, SquareIcon, StackCompactIcon, StarIcon, StrikethroughIcon, SunIcon, SyncIcon, TerminalIcon, ThLargeIcon, ThListIcon, ToggleArrowRightIcon, TokenIcon, TrashIcon, TrendUpwardIcon, TriangleOutlineIcon, TruncateIcon, UlistIcon, UnderlineIcon, UndoIcon, UnknownIcon, UnlockIcon, UnpublishIcon, UploadIcon, UserIcon, UsersIcon, WarningFilledIcon, WarningOutlineIcon, };
export const icons = {
    activity: ActivityIcon,
    'add-circle': AddCircleIcon,
    add: AddIcon,
    archive: ArchiveIcon,
    'arrow-down': ArrowDownIcon,
    'arrow-left': ArrowLeftIcon,
    'arrow-right': ArrowRightIcon,
    'arrow-up': ArrowUpIcon,
    bell: BellIcon,
    bill: BillIcon,
    'binary-document': BinaryDocumentIcon,
    'block-element': BlockElementIcon,
    blockquote: BlockquoteIcon,
    bold: BoldIcon,
    book: BookIcon,
    bottle: BottleIcon,
    'bulb-filled': BulbFilledIcon,
    'bulb-outline': BulbOutlineIcon,
    calendar: CalendarIcon,
    'chart-upward': ChartUpwardIcon,
    'checkmark-circle': CheckmarkCircleIcon,
    checkmark: CheckmarkIcon,
    'chevron-down': ChevronDownIcon,
    'chevron-left': ChevronLeftIcon,
    'chevron-right': ChevronRightIcon,
    'chevron-up': ChevronUpIcon,
    circle: CircleIcon,
    clipboard: ClipboardIcon,
    'clipboard-image': ClipboardImageIcon,
    clock: ClockIcon,
    'close-circle': CloseCircleIcon,
    close: CloseIcon,
    'code-block': CodeBlockIcon,
    code: CodeIcon,
    cog: CogIcon,
    collapse: CollapseIcon,
    comment: CommentIcon,
    component: ComponentIcon,
    compose: ComposeIcon,
    controls: ControlsIcon,
    dashboard: DashboardIcon,
    database: DatabaseIcon,
    document: DocumentIcon,
    'document-remove': DocumentRemoveIcon,
    documents: DocumentsIcon,
    download: DownloadIcon,
    'drag-handle': DragHandleIcon,
    drop: DropIcon,
    'earth-americas': EarthAmericasIcon,
    'earth-globe': EarthGlobeIcon,
    edit: EditIcon,
    'ellipsis-horizontal': EllipsisHorizontalIcon,
    'ellipsis-vertical': EllipsisVerticalIcon,
    equal: EqualIcon,
    'error-filled': ErrorFilledIcon,
    'error-outline': ErrorOutlineIcon,
    expand: ExpandIcon,
    'eye-closed': EyeClosedIcon,
    'eye-open': EyeOpenIcon,
    folder: FolderIcon,
    generate: GenerateIcon,
    heart: HeartIcon,
    'help-circle': HelpCircleIcon,
    home: HomeIcon,
    'ice-cream': IceCreamIcon,
    image: ImageIcon,
    'image-remove': ImageRemoveIcon,
    images: ImagesIcon,
    'info-filled': InfoFilledIcon,
    'info-outline': InfoOutlineIcon,
    'inline-element': InlineElementIcon,
    italic: ItalicIcon,
    joystick: JoystickIcon,
    launch: LaunchIcon,
    leave: LeaveIcon,
    lemon: LemonIcon,
    link: LinkIcon,
    'link-removed': LinkRemovedIcon,
    lock: LockIcon,
    'master-detail': MasterDetailIcon,
    menu: MenuIcon,
    'mobile-device': MobileDeviceIcon,
    moon: MoonIcon,
    'ok-hand': OkHandIcon,
    olist: OlistIcon,
    package: PackageIcon,
    pause: PauseIcon,
    pin: PinIcon,
    'pin-removed': PinRemovedIcon,
    play: PlayIcon,
    plug: PlugIcon,
    publish: PublishIcon,
    'remove-circle': RemoveCircleIcon,
    remove: RemoveIcon,
    reset: ResetIcon,
    restore: RestoreIcon,
    revert: RevertIcon,
    robot: RobotIcon,
    rocket: RocketIcon,
    search: SearchIcon,
    select: SelectIcon,
    sort: SortIcon,
    spinner: SpinnerIcon,
    'split-horizontal': SplitHorizontalIcon,
    'split-vertical': SplitVerticalIcon,
    square: SquareIcon,
    'stack-compact': StackCompactIcon,
    star: StarIcon,
    strikethrough: StrikethroughIcon,
    sun: SunIcon,
    sync: SyncIcon,
    terminal: TerminalIcon,
    'th-large': ThLargeIcon,
    'th-list': ThListIcon,
    'toggle-arrow-right': ToggleArrowRightIcon,
    token: TokenIcon,
    trash: TrashIcon,
    'trend-upward': TrendUpwardIcon,
    'triangle-outline': TriangleOutlineIcon,
    truncate: TruncateIcon,
    ulist: UlistIcon,
    underline: UnderlineIcon,
    undo: UndoIcon,
    unknown: UnknownIcon,
    unlock: UnlockIcon,
    unpublish: UnpublishIcon,
    upload: UploadIcon,
    user: UserIcon,
    users: UsersIcon,
    'warning-filled': WarningFilledIcon,
    'warning-outline': WarningOutlineIcon,
};
//# sourceMappingURL=index.js.map